var map = {
	"./advancedSearch/saga.js": 338,
	"./agent/saga.js": 544,
	"./auth/saga.js": 501,
	"./benchmark/saga.js": 505,
	"./businessAdmin/saga.js": 545,
	"./dashboard/saga.js": 506,
	"./datasetDetail/saga.js": 507,
	"./datasetDetail_v2/saga.js": 546,
	"./datasets/saga.js": 547,
	"./enterprise/saga.js": 548,
	"./issue/saga.js": 549,
	"./labelingEvaluationReport/saga.js": 527,
	"./members/saga.js": 528,
	"./model/saga.js": 529,
	"./modelManagement/saga.js": 550,
	"./notification/saga.js": 551,
	"./organization/saga.js": 538,
	"./permissions/saga.js": 552,
	"./pricing/saga.js": 543,
	"./projects/saga.js": 539,
	"./socket/saga.js": 40,
	"./surveyDetail/saga.js": 540,
	"./tags/saga.js": 553,
	"./tour/saga.js": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;